"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var chars = {
    cr: "\r",
    lf: "\n",
    tab: "\t",
    space: " ",
    zero: "0",
    nine: "9",
    a: "a",
    z: "z",
    A: "A",
    Z: "Z"
};
var charCodes = {
    cr: chars.cr.charCodeAt(0),
    lf: chars.lf.charCodeAt(0),
    tab: chars.tab.charCodeAt(0),
    space: chars.space.charCodeAt(0),
    zero: chars.zero.charCodeAt(0),
    nine: chars.nine.charCodeAt(0),
    a: chars.a.charCodeAt(0),
    z: chars.z.charCodeAt(0),
    A: chars.A.charCodeAt(0),
    Z: chars.Z.charCodeAt(0)
};
var isWhitespace = function (ch) {
    var code = ch.charCodeAt(0);
    return isNaN(code) ||
        (code >= 9 && code <= 13) ||
        code === 32 ||
        code === 133 ||
        code === 160 ||
        code === 5760 ||
        (code >= 8192 && code <= 8202) ||
        code === 8232 ||
        code === 8233 ||
        code === 8239 ||
        code === 8287 ||
        code === 12288;
};
exports.isWhitespace = isWhitespace;
exports.whitespace = isWhitespace;
var isNotWhitespace = function (ch) {
    return !isWhitespace(ch);
};
exports.isNotWhitespace = isNotWhitespace;
exports.nonWhitespace = isNotWhitespace;
var isDigit = function (ch) {
    var code = ch.charCodeAt(0);
    return code >= charCodes.zero && code <= charCodes.nine;
};
exports.isDigit = isDigit;
exports.digit = isDigit;
var isNotDigit = function (ch) {
    return !isDigit(ch);
};
exports.isNotDigit = isNotDigit;
exports.nonDigit = isNotDigit;
var isAlpha = function (ch) {
    var code = ch.charCodeAt(0);
    return (code >= charCodes.a && code <= charCodes.z) || (code >= charCodes.A && code <= charCodes.Z);
};
exports.isAlpha = isAlpha;
exports.alpha = isAlpha;
var isNotAlpha = function (ch) {
    return !isAlpha(ch);
};
exports.isNotAlpha = isNotAlpha;
exports.nonAlpha = isNotAlpha;
var isAlphaNumeric = function (ch) {
    return isAlpha(ch) || isDigit(ch);
};
exports.isAlphaNumeric = isAlphaNumeric;
exports.alphaNumeric = isAlphaNumeric;
var isNotAlphaNumeric = function (ch) {
    return !isAlpha(ch) && !isDigit(ch);
};
exports.isNotAlphaNumeric = isNotAlphaNumeric;
exports.nonAlphaNumeric = isNotAlphaNumeric;
